// extracted by mini-css-extract-plugin
export default {"searchInput":"CreateTeamModal_searchInput__cr2vd","createTeamWrap":"CreateTeamModal_createTeamWrap__-aeA2"};